import { isFieldFixed, shouldUseDefault } from "../../helpers";

export const setDefaults = (sheetData, defaults) => {
  // Capital
  if (
    !isFieldFixed(sheetData.capital.volumeSelection) &&
    (sheetData.capital.volumeSelection.value === 0 ||
      sheetData.capital.volumeSelection.value === null)
  ) {
    sheetData.capital.volumeSelection.value =
      defaults.defaultVolumeSelectionValue;
  }
  if (
    !isFieldFixed(sheetData.capital.totalDevicesOnSchedule) &&
    (sheetData.capital.totalDevicesOnSchedule.value === 0 ||
      sheetData.capital.totalDevicesOnSchedule.value === null)
  ) {
    sheetData.capital.totalDevicesOnSchedule.value =
      defaults.defaultAndMinimumTotalDevicesOnScheduleValue;
  }

  [
    sheetData.capital.funder,
    sheetData.capital.cofunded,
    sheetData.capital.dealer,
    sheetData.capital.funderSoftware,
    sheetData.capital.cofundedSoftware,
    sheetData.capital.dealerSoftware,
  ]
    .filter(Boolean)
    .forEach((section) =>
      defaultFundingSection(section, defaults, sheetData.rates),
    );

  return sheetData;
};

const findFmv = (ratesSection, fundingSection) =>
  [
    ratesSection.funderFmv,
    ratesSection.cofundedFmv,
    ratesSection.dealerFmv,
    ratesSection.funderFmvSoftware,
    ratesSection.cofundedFmvSoftware,
    ratesSection.dealerFmvSoftware,
  ]
    .filter(Boolean)
    .find(
      (x) =>
        x.funderType == fundingSection.funderType &&
        x.calcTableType == fundingSection.calcTableType,
    );

const findRateTableDefaults = (defaults, fundingSection, ratesSection) => {
  const fmv = findFmv(ratesSection, fundingSection);

  return (
    (defaults.rateTables || []).find(
      (x) =>
        x.funderType == fundingSection.funderType &&
        x.calcTableType == fundingSection.calcTableType &&
        x.financeType == fmv?.financeType &&
        x.paymentMethod == ratesSection.paymentMethod,
    ) || {}
  );
};

export const defaultFundingSection = (
  fundingSection,
  defaults,
  ratesSection,
) => {
  const funderDefaults =
    defaults.funderTypeSettings.find(
      (x) =>
        x.funderType == fundingSection.funderType &&
        x.calcTableType == fundingSection.calcTableType,
    ) || {};

  const rateTableDefaults = findRateTableDefaults(
    defaults,
    fundingSection,
    ratesSection,
  );
  if (!isFieldFixed(fundingSection.financeSelection)) {
    if (
      fundingSection.financeSelection.value === 0 ||
      fundingSection.financeSelection.value == null
    ) {
      fundingSection.financeSelection.value =
        funderDefaults.defaultQtrSelection;
    }
  }

  if (!isFieldFixed(fundingSection.ipSyndicatePercentageYield)) {
    if (
      fundingSection.ipSyndicatePercentageYield.value === 0 ||
      fundingSection.ipSyndicatePercentageYield.value == null
    ) {
      const defaultYieldPercentage = defaults.defaultYieldPercentages.find(
        (x) =>
          x.quarter == fundingSection.financeSelection.value &&
          x.paymentMethod == ratesSection.paymentMethod &&
          x.financeType == ratesSection.dealerFmv.financeType,
      );
      fundingSection.ipSyndicatePercentageYield.value =
        defaultYieldPercentage?.yieldPercentage || 0;
    }
  }

  shouldUseDefault(fundingSection.rrp) &&
    (fundingSection.rrp.value = rateTableDefaults.defaultRrp ?? null);
  shouldUseDefault(fundingSection.productCapitalCosts) &&
    (fundingSection.productCapitalCosts.value =
      rateTableDefaults.defaultProdCapCost ?? null);
  shouldUseDefault(fundingSection.otherCosts) &&
    (fundingSection.otherCosts.value = 0);
};
